import { useState, useEffect } from "react";
import { Menu, X } from "lucide-react";
import { Button } from "../components/ui/button";

const navLinks = [
  { label: "Servizi", href: "#servizi" },
  { label: "Metodo", href: "#metodo" },
  { label: "Testimonianze", href: "#testimonianze" },
  { label: "FAQ", href: "#faq" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollTo = (href) => {
    setMobileOpen(false);
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <nav
      data-testid="navbar"
      className={`fixed top-0 w-full z-50 transition-all duration-300 ${
        scrolled
          ? "bg-white/90 backdrop-blur-md border-b border-slate-200/60 shadow-sm"
          : "bg-transparent"
      }`}
    >
      <div className="container mx-auto px-4 md:px-6 lg:px-8 max-w-7xl flex items-center justify-between h-16">
        <a href="#hero" onClick={() => scrollTo("#hero")} className="flex items-center gap-2" data-testid="navbar-logo">
          <img 
            src="https://customer-assets.emergentagent.com/job_ai-agency-book/artifacts/uwykpigj_LOGO%20COLIBRI%20VERDE.png" 
            alt="Colibri Marketing Agency" 
            className="h-12 w-auto"
          />
        </a>

        <div className="hidden lg:flex items-center gap-8">
          {navLinks.map((link) => (
            <button
              key={link.href}
              onClick={() => scrollTo(link.href)}
              className="text-sm font-medium text-slate-600 hover:text-slate-900 transition-colors"
              data-testid={`nav-link-${link.href.replace('#', '')}`}
            >
              {link.label}
            </button>
          ))}
          <Button
            onClick={() => scrollTo("#contatti")}
            className="bg-[#1B4332] hover:bg-[#143728] text-white rounded-full h-10 px-6 text-sm font-medium shadow-lg shadow-green-900/20"
            data-testid="nav-cta-button"
          >
            Prenota una Call
          </Button>
        </div>

        <button
          className="lg:hidden p-2"
          onClick={() => setMobileOpen(!mobileOpen)}
          data-testid="mobile-menu-toggle"
        >
          {mobileOpen ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      {mobileOpen && (
        <div className="lg:hidden bg-white border-t border-slate-100 shadow-lg" data-testid="mobile-menu">
          <div className="px-4 py-4 space-y-3">
            {navLinks.map((link) => (
              <button
                key={link.href}
                onClick={() => scrollTo(link.href)}
                className="block w-full text-left py-2 text-slate-600 hover:text-slate-900 font-medium"
              >
                {link.label}
              </button>
            ))}
            <Button
              onClick={() => scrollTo("#contatti")}
              className="w-full bg-[#1B4332] hover:bg-[#143728] text-white rounded-full h-10 text-sm font-medium"
              data-testid="mobile-cta-button"
            >
              Prenota una Call
            </Button>
          </div>
        </div>
      )}
    </nav>
  );
}
